export type TextPart = { type: "text"; text: string };

export type ReasoningPart = { type: "reasoning"; text: string };

export type ToolCallPart = {
	type: "tool-call";
	toolCallId: string;
	toolName: string;
	input?: unknown;
	args?: unknown;
};

export type ToolResultPart = {
	type: "tool-result";
	toolCallId: string;
	toolName: string;
	output?: unknown;
	result?: unknown;
};

export type SourcePart = {
	type: "source" | "source-url" | "source-document";
	url?: string;
	title?: string;
	description?: string;
	sourceType?: string;
};

export type PlanContentPart = {
	type: "plan";
	title?: string;
	intro?: string;
	steps: { title: string; body?: string }[];
};

export type UnknownPart = { type: string; [key: string]: unknown };

export type ContentPart =
	| TextPart
	| ReasoningPart
	| ToolCallPart
	| ToolResultPart
	| SourcePart
	| PlanContentPart
	| UnknownPart;

export const isText = (p: ContentPart): p is TextPart => p.type === "text";

export const isReasoning = (p: ContentPart): p is ReasoningPart =>
	p.type === "reasoning";

export const isToolCall = (p: ContentPart): p is ToolCallPart =>
	p.type === "tool-call";

export const isToolResult = (p: ContentPart): p is ToolResultPart =>
	p.type === "tool-result";

export const isSource = (p: ContentPart): p is SourcePart =>
	p.type === "source" ||
	p.type === "source-url" ||
	p.type === "source-document";

export const isPlan = (p: ContentPart): p is PlanContentPart =>
	p.type === "plan";
